<p>global-styles works!</p>
